import {
  Avatar,
  Button,
  Col,
  DatePicker,
  Icon,
  Row,
  Select,
  Tag,
  Drawer,
  Tooltip,
} from 'antd'
import lodash from 'lodash'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import {
  ConditionOptions,
  Intakes,
  defaultLogoList,
  departmentObj,
  filterOption,
  longDisplayDate,
  newFormatDisplayDate,
  showEnrollmentAction,
  statusColors,
  udaanArr,
  currentUdaan
} from '../../../components/_utils/appUtils'
import { getPushPathWrapper, getUrlPushWrapper } from '../../../routes/routes'
import {
  CheckBranchUserFxn,
  ShowEnrollmentComponent
} from '../../WebComponent/allowComponentRightsWise'
import { CheckUserRight } from '../../dashboard/views/DashboardUserWise'
import {
  applicationCloseDirect,
  reCalculateCommission,
  updateApplicationTuitionFees
} from '../../student/actions/student'
import ApplyCourse from '../../student/views/applyForApplicationDrawer'
import {
  listAllUniversities,
  userWiseUniversityList
} from '../../university/actions/university'
import AddCommissionDrawer from '../../universityCommission/drawers/addCommission'
import { listAllUsers } from '../../users/actions/user'
import {
  getSelectedCountryApplicationsApi
} from '../../../containers/applications/actions/chooseStudent'

const { RangePicker } = DatePicker

const managerViewRight = ['admin', 'branchUser']

const { Option } = Select
const initialState = {
  applicationList: [],
  applicationObj: {}
}
const commissionObj = {
  commissionAmount: 0,
  tuitionFee: 0,
  studentId: '',
  applicationId: ''
}

const stringDate = date => {
  return date ? moment(date).format('YYYY-MM-DD') : null
}

const RenderComment = props => {
  let { item } = props
  let [hideV, setHideV] = useState(true)
  return (
    item && (
      <div>
        {item.addedByUserId && item.addedByUserId.name ? (
          <div className={'alignRight colorPrimary font12'}>
            (Added By : {item.addedByUserId.name})
          </div>
        ) : null}

        <div>{longDisplayDate(item.time)}</div>

        <div className={hideV ? 'appCommentDotsReplace' : ''}>
          {item && item.text ? item.text : ''}
        </div>
        {item && item.text.length && item.text.length > 50 ? (
          <div className={'alignRight'}>
            {hideV ? (
              <a
                onClick={() => {
                  setHideV(false)
                }}>
                Show More
              </a>
            ) : (
              <a
                onClick={() => {
                  setHideV(true)
                }}>
                Show Less
              </a>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  )
}
const PendingStudentApplicationListDrawer = props => {
  let {studentObj = {}, countryId, visible, onClose, addedType = 'note', currentUser,universityId} = props
  const [state, setState] = useState(initialState)
  const [transferAppVisible, setTransferAppVisible] = useState(false)
  const [studentData, setStudentData] = useState({})
  const [visibleAddCourseDrawer, setVisibleAddCourseDrawer] = useState(false)
  const [addPendencyDrawer, setAddPendencyDrawer] = useState(false)
  const [name, setName] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [allAgent, setAllAgent] = useState([])
  const [agentId, setAgentId] = useState('')
  const [universityList, setUniversityList] = useState([])
  const [appUniversityId, setAppUniversityId] = useState(universityId)
  const [visibleOtherAppDrawer, setVisibleOtherAppDrawer] = useState(false)
  const [visibleAddCommentDrawer, setVisibleAddCommentDrawer] = useState(false)
  const [totalApplication, setTotalApplication] = useState(0)
  const [visibleFeesModal, setVisibleFeesModal] = useState(false)
  const [feesObj, setFeesObj] = useState(commissionObj)
  const [currentStatus, setCurrentStatus] = useState('')
  let [intake, setIntake] = useState('')
  let [tableSearch, setTableSearch] = useState(false)
  let [filters, setFilters] = useState({})
  let [branchManagerList, setBranchManagerList] = useState([])
  let [studentManagerList, setStudentManagerList] = useState([])
  let [branchManagerId, setBranchManagerId] = useState('')
  let [studentManagerId, setStudentManagerId] = useState('')
  const [branchUserList, setBranchUserList] = useState([])
  const [branchUserId, setBranchUserId] = useState('')
  const [draftApplication, setDraftApplication] = useState('')
  const [visibleUpdateUser, setVisibleUpdateUser] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})
  const [defaultCountryId, setDefaultCountryId] = useState('')
  const [visibleTuitionFee, setVisibleTuitionFee] = useState(false)
  const [visibleOshcDrawer, setVisibleOshcDrawer] = useState(false)
  const [
    visibleUniversityCommission,
    setVisibleUniversityCommission
  ] = useState(false)
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [udaan, setUdaan] = useState('')

  let viewOnlyRight = CheckBranchUserFxn()


  const dispatch = useDispatch()
  let user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null
  const tableAppRef = useRef()

  const agentEvents = {
    closeEditUser: () => {
      setSelectedUser({})
      setVisibleUpdateUser(false)
    },
    editAgent: agent => {
      setSelectedUser(agent)
      setVisibleUpdateUser(true)
    }
  }


  const loadCurrentUserData = async () => {
    let { countryId } = await getParamsForApplicationList()
    if (countryId) {
      let params = {
        results: 1000,
        userType: 'branchUser',
        sortField: 'name',
        sortOrder: 'ascend',
        select: ['name', 'userType', 'mobile', 'email'],
        customQuery: {
          $or: [
            { countryId: countryId },
            { department: 'Visa Approved Department' }
          ]
        }
      }
      let { data } = await dispatch(listAllUsers(params))
      if (data && data.length) {
        setBranchUserList(data)
      }
    } else {
      setBranchUserList([])
    }
  }

  let apiRequest = params => {
    return new Promise(async resolve => {
      let resp = await getParamsForApplicationList()
      params = { ...params, ...resp }
      if (!params.countryId) {
        params.countryId = ''
      }
      if (!params.results) {
        params.results = 50
        params.count = 50
      }
      if (tableSearch) {
        params.page = 1
      }
      params.status = 'Visa Approved'
      params.appUniversityId = appUniversityId
      params.commissionAdded = false

      try {
        setFilters(params)
        let resp = await dispatch(
          getSelectedCountryApplicationsApi({
            ...params,
            regExFilters: ['name']
          })
        )
        setTotalApplication(resp.total)
        setTableSearch(false)
        resolve(resp)
      } catch (e) {
      }
    })
  }



  useEffect(() => {
    loadAgentData()
    LoadUserWiseUniversity()
    setFieldByParams()

    loadCurrentUserData()
  }, [])

  const setFieldByParams = async () => {
    let resp = await getParamsForApplicationList()
    setCurrentStatus(resp.status)
    if (resp.status == 'Visa Approved' || resp.status == 'Case Approved') {
      setUdaan(currentUdaan)
    }
    if (resp.countryId) {
      setDefaultCountryId(resp.countryId)
    }
    if (resp.name) {
      setName(resp.name)
    }
    if (resp.intake) {
      setIntake(resp.intake)
    }
    if (resp.agentId) {
      setAgentId(resp.agentId)
    }
    if (resp.appUniversityId) {
      setAppUniversityId(resp.appUniversityId)
    }
    if (resp.branchManagerId) {
      setBranchManagerId(resp.branchManagerId)
    }
    if (resp.draftApplication) {
      setDraftApplication(resp.draftApplication)
    }
    if (resp.studentManagerId) {
      setStudentManagerId(resp.studentManagerId)
    }
    if (resp.branchUserId) {
      setBranchUserId(resp.branchUserId)
    }
    if (resp.fromDate) {
      setFromDate(moment(resp.fromDate))
    }
    if (resp.toDate) {
      setToDate(moment(resp.toDate))
    }
  }

  const loadAgentData = async () => {
    let params = {
      results: 15000,
      userType: 'agent',
      sortField: 'companyName',
      sortOrder: 'ascend',
      select: ['name', 'companyName']
    }
    let { data } = await dispatch(listAllUsers(params))
    if (data && data.length) {
      setAllAgent(data)
    }
  }
  const loadUniversityNameList = async () => {
    let params = {
      results: 5000,
      select: ['universityName'],
      sortField: 'universityName',
      sortOrder: 'ascend',
      regExFilters: ['universityName'],
      showUniversity: [true, false]
    }
    let resp = await getParamsForApplicationList()

    params.universityCountry = resp.countryId

    let { data } = await dispatch(listAllUniversities(params))
    if (data && data.length) {
      setUniversityList(data)
    }
  }

  const LoadUserWiseUniversity = async () => {
    // let { countryId } = await getParamsForApplicationList()
    let data = await dispatch(userWiseUniversityList({ countryId }))
    // setAppUniversityId('')
    if (data && data.length) {
      setUniversityList(data)
    }
  }
  const events = {
    openAddPendencyDrawer: value => {
      setState({
        ...state,
        applicationObj: value
      })
      setAddPendencyDrawer(true)
    },
    reloadAndClose: () => {
      tableAppRef.current.reload()
      setAddPendencyDrawer(false)
    },
    closeAddPendencyDrawer: () => {
      setState({
        ...state,
        applicationObj: {}
      })
      setAddPendencyDrawer(false)
    },
    reloadFxn: () => {
      tableAppRef.current.reload()
    },
    showTransferApp: () => {
      setTransferAppVisible(true)
    },
    hideTransferApp: () => {
      setTransferAppVisible(false)
      tableAppRef.current.reload()
    },
    showAddCourseDrawer: () => {
      setVisibleAddCourseDrawer(true)
    },
    hideAddCourseDrawer: () => {
      setVisibleAddCourseDrawer(false)
      tableAppRef.current.reload()
    },
    refreshApplication: () => {
      tableAppRef.current.reload()
    },

    closeDirectApp: async record => {
      let obj = {
        studentId: record._id,
        applicationId: record.applications._id
      }
      let resp = await dispatch(applicationCloseDirect(obj))
      tableAppRef.current.reload()
    },

    enterName: value => {
      setName(value)
    },
    openOtherAppDrawer: value => {
      setState({
        ...state,
        applicationObj: value
      })
      setVisibleOtherAppDrawer(true)
    },
    closeOtherAppDrawer: () => {
      setState({
        ...state,
        applicationObj: {}
      })
      setVisibleOtherAppDrawer(false)
    },
    openAddCommentDrawer: value => {
      setState({
        ...state,
        applicationObj: value
      })
      setVisibleAddCommentDrawer(true)
    },
    closeAddCommentDrawer: () => {
      setState({
        ...state,
        applicationObj: {}
      })
      setVisibleAddCommentDrawer(false)
    },
    hideVisibleFeesModal: () => {
      setVisibleFeesModal(false)
    },
    setCommissionLocal: data => {
      setFeesObj({
        ...feesObj,
        ...data
      })
    },
    reCalculateCommissionFxn: async () => {
      let { commissionAmount } = await dispatch(reCalculateCommission(feesObj))
      if (commissionAmount) {
        events.setCommissionLocal({ commissionAmount })
      }
    },
    updateApplicationTuitionFeesFxn: async () => {
      let { success, message } = await dispatch(
        updateApplicationTuitionFees(feesObj)
      )
      if (success) {
        setFeesObj(commissionObj)
        setVisibleFeesModal(false)
        events.reloadFxn()
      }
    },
    showTuitionFeeDrawer: () => {
      setVisibleTuitionFee(true)
    },
    hideTuitionFeeDrawer: () => {
      setVisibleTuitionFee(false)
      tableAppRef.current.reload()
    },
    showOshcDrawer: () => {
      setVisibleOshcDrawer(true)
    },
    hideOshcDrawer: () => {
      setVisibleOshcDrawer(false)
      tableAppRef.current.reload()
    },
    showUniversityCommission: () => {
      setVisibleUniversityCommission(true)
    },
    hideUniversityCommission: () => {
      setVisibleUniversityCommission(false)
      tableAppRef.current.reload()
    },
    chooseDate: data => {
      if (data && data.length) {
        setFromDate(stringDate(data[0]))
        setToDate(stringDate(data[1]))
      }
    }
  }

  const showEnrollmentBtn = record => {
    let application = record.applications
    return showEnrollmentAction(application.statusList) ? true : false
  }

  const getParamsForApplicationList = () => {
    return new Promise(resolve => {
      let obj = {
        countryId,
      }
      if (agentId) {
        obj.agentId = agentId
      }
      if (appUniversityId) {
        obj.appUniversityId = appUniversityId
      }
      if (name) {
        obj.name = name
      }
      if (intake) {
        obj.intake = intake
      }
      if (branchUserId) {
        obj.branchUserId = branchUserId
      }
      if (branchManagerId) {
        obj.branchManagerId = branchManagerId
      }
      if (studentManagerId) {
        obj.studentManagerId = studentManagerId
      }
      if (draftApplication) {
        obj.draftApplication = draftApplication
      }
      if (fromDate) {
        obj.fromDate = fromDate
      }
      if (toDate) {
        obj.toDate = toDate
      }
      if (udaan) {
        obj.udaan = udaan
      }
      resolve(obj)
    })
  }

  const searchFxn = async () => {
    let resp = await getParamsForApplicationList()
    let obj = {
      countryId: resp.countryId,
      status: resp.status
    }
    if (name) {
      obj.name = name
    }
    if (agentId) {
      obj.agentId = agentId
    }
    if (appUniversityId) {
      obj.appUniversityId = appUniversityId
    }
    if (intake) {
      obj.intake = intake
    }
    if (branchUserId) {
      obj.branchUserId = branchUserId
    }
    if (branchManagerId) {
      obj.branchManagerId = branchManagerId
    }
    if (studentManagerId) {
      obj.studentManagerId = studentManagerId
    }
    if (draftApplication) {
      obj.draftApplication = draftApplication
    }
    if (fromDate) {
      obj.fromDate = fromDate
    }
    if (toDate) {
      obj.toDate = toDate
    }
    if (udaan) {
      obj.udaan = udaan
    }
    setTableSearch(true)
    setTimeout(() => {
      tableAppRef.current.reload()
    }, 300)
  }
  const clearFxn = async () => {
    let resp = await getParamsForApplicationList()
    let obj = {
      countryId: resp.countryId,
      status: resp.status
    }
    if (resp.draftApplication) {
      obj.draftApplication = resp.draftApplication
    }
    setAppUniversityId('')
    setAgentId('')
    setName('')
    setIntake('')
    setBranchManagerId('')
    setStudentManagerId('')
    setDraftApplication('')
    setBranchUserId('')
    setFromDate(null)
    setToDate(null)
    setUdaan(null)
    setTableSearch(true)
    setTimeout(() => {
      tableAppRef.current.reload()
    }, 200)
  }

  const commissionRight = () => {
    if (user.userType === 'admin') {
      return false
    }
    if (user.userType === 'agent') {
      return false
    }
    if (user.userType === 'branchUser') {
      if (user.department === 'Visa Approved Department') return false
    }
    return true
  }

  const columns = [
    {
      title: 'App#',
      key: 'applications.id',
      dataIndex: 'applications.id',
      searchTextName: 'applications.id',
      width: 100,
      render: item => {
        return <div style={{ width: 60 }}>{item}</div>
      }
    },
    {
      title: 'S.Id',
      key: 'studentId',
      dataIndex: 'studentId',
      width: 100,
      render: (item, record) => {
        return (
          <div>
            <label className={'label label-tag'}>ID : {item}</label><br />

          </div>
        )
      }
    },
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      width: 150,
      render: (item, record) => {
        let { applications, createdAt } = record
        return (
          <>
            <Tooltip title={'Edit Student'}>
              {record && record.countryISOCode == 'CA_+1' ? (
                <img
                  src={'/assets/starEnable.png'}
                  width={14}
                  style={{ marginRight: 3 }}
                />
              ) : null}
              <a
                className={'linkAA'}
                onClick={() =>
                  viewOnlyRight
                    ? dispatch(
                    getPushPathWrapper('student.editStudent', {
                      id: record._id
                    })
                    )
                    : ''
                }>
                {item} {viewOnlyRight ? <Icon type={'edit'} /> : ''}
              </a>
            </Tooltip>
            <br />

            {record && record.countryISOCode == 'CA_+1' ? (
              <span>
                <Tag style={{ marginTop: 3, marginBottom: 3 }} size={'sm'}>
                  Docs:{' '}
                  {applications && applications.paymentPending == true ? (
                    <Icon type={'close'} style={{ color: 'red' }} />
                  ) : (
                    <Icon type={'check'} style={{ color: 'limegreen' }} />
                  )}
                </Tag>
                <br />
                <Tag>
                  Fees:{' '}
                  {record && record.documentsPending == true ? (
                    <Icon type={'close'} style={{ color: 'red' }} />
                  ) : (
                    <Icon type={'check'} style={{ color: 'limegreen' }} />
                  )}
                </Tag>
              </span>
            ) : null}


            {createdAt ? <label className={'label label-tag'}>
              Join : {newFormatDisplayDate(createdAt)}
            </label> : null}
          </>
        )
      }
    },
    {
      title: 'DOB',
      dataIndex: 'dateOfBirth',
      key: 'dateOfBirth',
      width: 90,
      render: val => {
        return <div style={{ width: 90 }}>{newFormatDisplayDate(val)}</div>
      }
    },
    {
      title: 'Status',
      key: 'applications.status',
      dataIndex: 'applications.status',
      width: 150,
      render: (item, record) => {
        let { statusList } = record.applications
        return (
          <React.Fragment>
            <div
              className={'label label1'}
              style={{ background: statusColors(item), width: 80, padding: 3 }}>
              {item}
            </div>

          </React.Fragment>
        )
      }
    },

    {
      title: 'University',
      key: 'applications.courseUniversity',
      dataIndex: 'applications.courseUniversity',
      width: 180,
      render: (item, record) => {
        return (
          <React.Fragment>
            {item && item.logo && item.logo.url ? (
              <Avatar src={item.logo.url} size={20} />
            ) : (
              <Avatar src={defaultLogoList.defaultUniversityLogo} size={20} />
            )}
            {item && item.universityName ? `  ${item.universityName}` : ''}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Country',
      key: 'applications.universityCountry',
      dataIndex: 'applications.universityCountry',
      width: 150,
      render: (item, record) => {
        let { applications } = record
        return (
          <React.Fragment>
            {item && item.countryName ? item.countryName : null},{' '}
            {record && record.stateName ? record.stateName : null}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Program',
      key: 'applications.courseName',
      dataIndex: 'applications.courseName',
      width: 180,
      render: (item, record) => {
        return <div style={{ width: 150 }}>{item}</div>
      }
    },
    {
      title: 'Intake',
      key: 'applications.intake',
      dataIndex: 'applications.intake',
      width: 150,
      render: (item, record) => {
        return (
          <React.Fragment>
            {item && item.month && item.year
              ? `${item.month}, ${item.year}`
              : ''}
          </React.Fragment>
        )
      }
    },
    /*    {
          title: 'Pendency',
          key: 'applications.pendencyArr',
          dataIndex: 'applications.pendencyArr',
          width: 100,
          render: (item, record) => {
            return (
              <React.Fragment>
                <Tooltip title={'Add Pendency'}>
                  <span
                    onClick={() =>
                      viewOnlyRight ? events.openAddPendencyDrawer(record) : ''
                    }
                    className='badge'>
                    {item && item.length ? getPendingPendency(item) : 0}
                  </span>
                </Tooltip>{' '}
              </React.Fragment>
            )
          }
        },*/

    {
      title: 'Current User',
      key: 'applications.assignedUserId',
      dataIndex: 'applications.assignedUserId',
      width: 250,
      render: (val, record) => {
        let {
          agentId,
          statusList,
          status,
          addByUserId,
          enrollment
        } = record.applications
        return (
          <React.Fragment>
            {val && val.name ? val.name : ''}
            <br />

            {agentId && agentId.companyName ? (
              <div>
                {user.department == departmentObj.assDepartment &&
                user.managerViewOnly
                  ? null
                  : `Agent : ${agentId.companyName}`}
                {!enrollment && showEnrollmentAction(statusList) ? (
                  <ShowEnrollmentComponent
                    rightUserType={['admin', 'branchUser']}>
                    <a onClick={() => agentEvents.editAgent(agentId)}>
                      <Icon type={'edit'} />
                    </a>
                  </ShowEnrollmentComponent>
                ) : null}
              </div>
            ) : (
              ''
            )}

            {addByUserId && addByUserId.name ? (
              <div className={'mt5 colorPrimary font12'}>
                (Added By :{' '}
                {addByUserId && addByUserId.name ? addByUserId.name : ''})
              </div>
            ) : (
              ''
            )}

            <CheckUserRight
              user={user}
              rightUserType={['admin', 'branchManager', 'branchUser']}>
              {agentId && agentId.mobile ? (
                <div>Mob : {agentId.mobile}</div>
              ) : (
                ''
              )}
            </CheckUserRight>
            <div>{longDisplayDate(statusList.date)}</div>
          </React.Fragment>
        )
      }
    },
    /* {
         title: 'Student Manager',
         dataIndex: 'branchManagerId',
         hidden: !managerViewRight.includes(user.userType),
         width: 125,
         key: 'branchManagerId',
         render: (item, record) => {
             let {branchManagerId} = record
             return (
                 <React.Fragment>
                     {branchManagerId ? branchManagerId.name : null}
                 </React.Fragment>
             )
         }
     }, */
    {
      title: 'Marketing',
      dataIndex: 'marketingUserId',
      hidden: !managerViewRight.includes(user.userType),
      width: 125,
      key: 'branchManagerId',
      render: (item, record) => {
        let { marketingUserId } = record.applications
        return (
          <React.Fragment>
            {marketingUserId && marketingUserId.name ? marketingUserId.name : null}
          </React.Fragment>
        )
      }
    },

    {
      title: 'Commission',
      key: 'commission',
      dataIndex: 'applications.commission',
      hidden: commissionRight(),
      width: 180,
      render: (item, record) => {
        return (
          <React.Fragment>
            {item && item.commissionAmount ? item.commissionAmount : null}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Latest Note',
      key: 'applications.latestComment',
      dataIndex: 'applications.latestComment',
      width: 250,
      render: val => {
        return (
          <div style={{ width: 200 }}>
            {val && val.text ? <RenderComment item={val} /> : null}
          </div>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      dataIndex: 'action',
      width: 100,
      fixed: 'right',
      render: (val, record) => {
        return (
          <div className={'actionBtnGroup'}>

            <Tooltip title={'Create Commission'}>
              <button
                className='btn'
                onClick={() => {
                  setStudentData(record)
                  events.showUniversityCommission()
                }}>
                <img src={'../btnImgs/percentage.png'} />
              </button>
            </Tooltip>
          </div>
        )
      }
    }
  ]


  let loadColumns = () => {
    let columnArr = []
    lodash.each(columns, item => {
      if (item.hidden == undefined) {
        columnArr.push(item)
      } else {
        if (!item.hidden) {
          columnArr.push(item)
        }
      }
    })
    return columnArr
  }

  const extra = (
    <Row gutter={12} className={'filter-row'}>
      <CheckUserRight
        user={user}
        rightUserType={['admin', 'branchManager', 'branchUser', 'userManager']}>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>
            <Select
              name='Current User'
              onChange={item => setBranchUserId(item)}
              filterOption={filterOption}
              className={'antSelect'}
              allowClear={true}
              showSearch={true}
              placeholder={'Current User'}
              value={branchUserId || undefined}>
              {branchUserList && branchUserList.length
                ? branchUserList.map((item, key) => {
                  return (
                    <Option value={item._id} key={key}>
                      {item.name}
                    </Option>
                  )
                })
                : null}
            </Select>
          </div>
        </Col>
      </CheckUserRight>

      <Col md={4} sm={4} xs={8} lg={4}>
        <div className='sort-box-table custom-sort-box-new'>
          <Select
            name='Intake'
            onChange={item => setIntake(item)}
            filterOption={filterOption}
            className={'antSelect'}
            allowClear={true}
            showSearch={true}
            placeholder={'Intake'}
            value={intake || undefined}>
            {Intakes && Intakes.length
              ? Intakes.map((item, key) => {
                return (
                  <Option value={item} key={key}>
                    {item}
                  </Option>
                )
              })
              : null}
          </Select>
        </div>
      </Col>

      <Col md={4} sm={4} xs={8} lg={4}>
        <div className='search-box-table round ml0'>
          <input
            className='form-control'
            type='search'
            placeholder='Search by name...'
            value={name}
            onChange={e => {
              events.enterName(e.target.value)
            }}
          />
          <img src='/dist/img/search.png' alt='' />
        </div>
      </Col>
      {currentStatus &&
      (currentStatus == 'Visa Approved' || currentStatus == 'Case Approved') ? (
        <>
          <Col md={4} sm={4} xs={8} lg={4}>
            <RangePicker
              value={[
                fromDate ? moment(fromDate, 'YYYY-MM-DD') : null,
                toDate ? moment(toDate, 'YYYY-MM-DD') : null
              ]}
              className={'round-date-picker'}
              onChange={events.chooseDate}
            />
          </Col>
        </>
      ) : null}
      {currentStatus && (currentStatus == 'Visa Approved' || currentStatus == 'Case Approved') &&
      (currentUser.userType !== 'agent' &&
        currentUser.userType !== 'subAgent') ? (
        <>
          <Col md={4} sm={4} xs={8} lg={4}>
            <div className='sort-box-table custom-sort-box-new'>
              <Select
                name='Choose Udaan'
                onChange={item => {
                  setUdaan(item)
                }}
                value={udaan || undefined}
                placeholder={'Udaan'}
                className={'antSelect'}
                allowClear={true}>
                {udaanArr && udaanArr.length
                  ? udaanArr.map((item, key) => {
                    return (
                      <Option value={item.value} key={item.value}>
                        {item.name}
                      </Option>
                    )
                  })
                  : null}
              </Select>
            </div>
          </Col>
        </>
      ) : null}
      <Col md={24} sm={24} xs={24} lg={24} className={'alignRight'}>
        <Button onClick={() => searchFxn()} className={'roundBtn'}>
          Search
        </Button>
        <Button onClick={() => clearFxn()} className={'roundBtn'}>
          Clear
        </Button>
      </Col>
    </Row>
  )

  return (
    <Drawer width={'92%'}
            title={'Pending Application List'}
            visible={visible}
            onClose={() => {
              onClose()
            }}>
      <React.Fragment>
        <div>
          <div className='row mt-4'>
            <div className='col-lg-12'>
              <div className='card'>

              <div className='card-body table-responsive'>
                {extra}
                <TableComp
                  columns={loadColumns()}
                  rowKey={(item, index) => {
                    return index
                  }}
                  apiRequest={apiRequest}
                  pagination={{
                    position: 'top',
                    showSizeChanger: true,
                    pageSizeOptions: ['50', '100', '200', '500'],
                    defaultPageSize: 50,
                    current: filters.page ? filters.page : 1
                  }}
                  extraProps={{ scroll: { x: 2000 } }}
                  ref={tableAppRef}
                />
              </div>
            </div>
          </div>
        </div>


      </div>




      {visibleUniversityCommission ? (
        <AddCommissionDrawer
          visible={visibleUniversityCommission}
          studentData={studentData}
          onClose={() => events.hideUniversityCommission()}
        />
      ) : (
        ''
      )}
    </React.Fragment>
    </Drawer>
  )
}
const mapStateToProps = ({ global, router, chooseApplication }) => ({
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingStudentApplicationListDrawer)
